import { useTriggeredMessageQuery } from '@occc/graphql';

export const useTriggeredMessage = (messageId: string) => {
  const response = useTriggeredMessageQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      uuid: messageId,
    },
  });

  return {
    ...response,
    data: response.data ? response.data.triggeredMessage : response.data,
  };
};
